var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30.8 28.2",
    style: {
      enableBackground: "new 0 0 30.8 28.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1D1B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000021840154948334767430000001504805108416910772_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    className: "st0",
    d: "M14.9,0h1c3.6,3,7.3,5.9,10.9,8.9c1.4,1.1,2.7,2.3,4.1,3.5v1c-0.9,1-1.4,1.1-2.5,0.2L27,12.4 v11.8c0.1,2.1-1.5,3.9-3.6,4c0,0,0,0,0,0l0,0c-0.1,0-0.2,0-0.4,0c-5.1,0-10.1,0-15.2,0c-2.1,0.1-3.9-1.5-4-3.6c0,0,0,0,0,0l0,0 v-0.4c0-3.6,0-7.3,0-10.9v-0.9l-1.5,1.2c-0.8,0.7-1.6,0.7-2.1,0s-0.3-1.4,0.5-2L14.9,0z M10.3,25.7c0-2.2,0-4.4,0-6.5 c0-2.1,1.7-3.8,3.8-3.8h2.2c2.1-0.2,4,1.3,4.2,3.4c0,0.3,0,0.5,0,0.8v6.1h2.2c1.2,0,1.7-0.5,1.7-1.7c0-4.4,0-8.7,0-13.1 c0-0.4-0.2-0.7-0.5-1c-1.1-1-2.3-2-3.5-2.9L15.4,3c-2.9,2.4-5.8,4.8-8.7,7.1c-0.2,0.2-0.3,0.4-0.3,0.6c0,4.5,0,9,0,13.6 c0,0.7,0.5,1.3,1.2,1.4h0.2C8.6,25.7,9.4,25.7,10.3,25.7L10.3,25.7z M18,25.7c0-2.2,0-4.2,0-6.3c0-0.7-0.5-1.3-1.2-1.4 c0,0,0,0,0,0h-0.1c-0.8,0-1.6,0-2.3,0c-0.7-0.1-1.4,0.5-1.4,1.2c0,0,0,0,0,0c0,0.1,0,0.2,0,0.2c0,1.5,0,2.9,0,4.4v1.8L18,25.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.0b59a610196a33cc5cec41c86d3820dd.svg";
export { ForwardRef as ReactComponent };